export default __webpack_public_path__ + "static/media/Aditya.07d13bce.jpg";